import { render } from "./decimalValue.vue?vue&type=template&id=76f8bbe6"
import script from "./decimalValue.vue?vue&type=script&lang=js"
export * from "./decimalValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__